import { render, staticRenderFns } from "./CadastrosCanaisLeads.vue?vue&type=template&id=479580f7"
import script from "./CadastrosCanaisLeads.vue?vue&type=script&lang=ts"
export * from "./CadastrosCanaisLeads.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports